import Loading, { LoadingInline } from './Loading'
export default Loading
export { LoadingInline }
